module.exports = __webpack_public_path__ + "static/img/9.7c9b369.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/yijia/9.png
// module id = a6ps
// module chunks = 0